var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#E5AA57"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_762_1123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.8336 36.9665L23.9719 43.483L12.6191 36.9536C11.3189 36.2066 10.5176 34.8211 10.5176 33.3218V9.39359L24.1115 7.51697L36.8679 9.39359V33.3735C36.8679 34.8443 36.095 36.2092 34.8336 36.9665Z",
    stroke: "white",
    strokeWidth: 1.03395,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1011 21.3332H16.2871V32.4223H31.1011V21.3332Z",
    stroke: "white",
    strokeWidth: 1.03395,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6918 13.3536L14.4043 21.3332H32.9818L23.6918 13.3536Z",
    stroke: "white",
    strokeWidth: 1.03395,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_762_1123"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.3842,
    height: 37,
    fill: "white",
    transform: "translate(10 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRi);
export default __webpack_public_path__ + "static/media/RI.51e158a8be1f2cf75bf1fd64f0044af0.svg";
export { ForwardRef as ReactComponent };